/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { pathOr } from "ramda";
import classnames from "classnames";

import GoodsList from "../../components/GoodsList";
import RecommendList from "../../components/RecommendList";
import MechanismSelection from "../../components/MechanismSelection";
import NoticeList from "../../components/NoticeList";
import ChuzhiNoticeList from "../../components/ChuzhiNoticeList";
import PizhuanList from "../../components/PizhuanList";
import OrgInfo from "../../components/OrgInfo/OrgInfo";
import ZhiboFloor from "../../components/ZhiboFloor/ZhiboFloor";
import BannerSwiper from "../../components/BannerSwiper/BannerSwiper";
import {fillImgPath, getUrlParms} from "../../utils/index";
import {
  ZICHANORGTABS,
  POCHANORGTABS,
  HAIGUANANDZFTABS,
  BUSINESS_INFO,
  getApiTypeByGetItem,
} from "../../constant";
import styles from "./Index.module.css";
import { IOrgInfo,TabItem,getGoods,getRecommend, getAdData, getPizhuanList, getChuzhiNoticeList } from "../../api";
import { initHeaderSearch } from "../../utils/search";


const Index: React.FC = props => {
  const id = pathOr(0, ["match", "params", "id"], props);
  const venderId = Number(id)
  const [active, setActive] = useState(0)
  const [publishSource, setPublishSource] = useState('')
  const [tabs, setTabs] = useState<TabItem[]>([])
  const [bannerList, setBannerList] = useState<any>([])
  const [chuzhiNoticeTotalCount, setChuzhiNoticeTotalCount] = useState(0);

  const [isShowPizhuanTab, setIsShowPizhuanTab] = useState(true)

  useEffect(() => {
    window.scrollTo(0, 0);
    if ((window as any).expLogJSON) {
      (window as any).expLogJSON('MPropertyPaiMai', 'MPropertyPaiMai_Shop', venderId);
    }
  }, []);


  const getbannerList = (publishSource: string) => {
    if (!venderId || !publishSource) return;
    let areaId = null;
    Object.keys(BUSINESS_INFO).forEach((key: string) => {
      const item = (BUSINESS_INFO as any)[key]
      if (item.code === publishSource && item.adAreaId) {
        areaId = item.adAreaId;
      }
    })
    if (!areaId) return;
    
    const params = {
      areaId,
      id: venderId
    }

    getAdData(params).then(res => {
      if (res && res.statusCode === 200 && res.data && res.data.length > 0) {
        const data = res.data.map((item:any) => {
          return {
            imgUrl: fillImgPath({url: item.imageUrl, size: '2400x180'}),
            linkUrl: item.url,
            content: item.content
          }
        })
        setBannerList(data)
      }
    })

  }

  const getPichuanTotalCount = (): Promise<number> => {
    return new Promise(resolve => {
      getPizhuanList({
        vendorId: '' + venderId,
        page: 1,
        pageSize: 1
      }).then(res => {
        resolve(res && res.totalItem ? res.totalItem : 0)
      }).catch(err => {
        resolve(0)
      })
    })
  }

  const getChuzhiNoticeTotalCount = (): Promise<number> => {
    return new Promise(resolve => {
      getChuzhiNoticeList({
        venderId,
        pageNo: 1,
        pageSize: 1
      }).then(res => {
        resolve(res && res.totalItem ? res.totalItem : 0)
      }).catch(err => {
        resolve(0)
      })
    })
  }

  const onOrgInfoLoaded = (info: IOrgInfo) => {
    document.title = info.shopName;
    initHeader(info);
    const publishSource = info.publishSource;
    setPublishSource(publishSource);
    getbannerList(publishSource);
    if (parseInt(publishSource) === BUSINESS_INFO.ZICHAN.code) {
      setTabs(ZICHANORGTABS);
      // 报价项目和处置项目需要动态获取，有才展示
      Promise.all([getPichuanTotalCount(), getChuzhiNoticeTotalCount()]).then(
        ([pizhuanTotalCount, chuzhiNoticeTotalCount]) => {
          let newTabs = [];
          if (pizhuanTotalCount) {
            newTabs.push({ id: 3, name: "报价项目" });
          }
          if (chuzhiNoticeTotalCount) {
            newTabs.push({ id: 4, name: "处置公告" });
            setChuzhiNoticeTotalCount(chuzhiNoticeTotalCount);
          }
          setTabs(ZICHANORGTABS.concat(newTabs));
        }
      );
    } else if (parseInt(publishSource) === BUSINESS_INFO.POCHAN.code) {
      setTabs(POCHANORGTABS);
    } else if (parseInt(publishSource) === BUSINESS_INFO.HAIGUANANDZF.code) {
      setTabs(HAIGUANANDZFTABS);
    }
    setCurTabIndex(publishSource);
  };

  const initHeader = (info: IOrgInfo) => {
    const { publishSource, assetType } = info;
    // 根据业务线展示对应的header
    const headers = document.querySelectorAll(
      "#paimai-common-header .header-item"
    );
    let matchedHeaderId = "";
    // 优先根据assetType匹配
    if (document.getElementById(`header-assetType-${assetType}`)) {
      matchedHeaderId = `header-assetType-${assetType}`;
    } else if (
      document.getElementById(`header-publishSource-${publishSource}`)
    ) {
      matchedHeaderId = `header-publishSource-${publishSource}`;
    }
    headers.forEach((header: any) => {
      if (header.id !== matchedHeaderId) {
        header.remove();
      } else {
        header.style.display = "block";
        initHeaderSearch(header.getAttribute("data-publishSource"));
      }
    });
  };

  //进入店铺时资产、破产业务线底部Tab默认显示规则
  const setCurTabIndex = (publishSource: string) => {
    let curTabIndex = 0;
    const auctionTypeMap = {
      [BUSINESS_INFO.POCHAN.code]: 5,
      [BUSINESS_INFO.HAIGUANANDZF.code]: 2,
      [BUSINESS_INFO.ZICHAN.code]: 4,
    };
    let paramsByGetRecommend: any = {
      page: 1,
      pageSize: 1,
      venderIdList: [venderId],
      auctionType: auctionTypeMap[parseInt(publishSource)] || 4,
    };
    if (parseInt(publishSource) === BUSINESS_INFO.ZICHAN.code) {
      paramsByGetRecommend.shopDisplay = 1; // 1 店铺页展示 0 店铺页不展示
    }
    Promise.all([
      getGoods({
        page: 1,
        pageSize: 1,
        vendorId: venderId,
        multiPaimaiStatus: "0,1",
        apiType: 12,
        // apiType: getApiTypeByGetItem(parseInt(publishSource))
      }),
      getRecommend(paramsByGetRecommend),
    ]).then((res) => {
      if (res && res.length === 2) {
        const auctionListNotEndList = res[0]; //预告中+进行中的拍品
        const promotionAuctionList = res[1]; //推介
        const auctionListNotEndListTotalItem = auctionListNotEndList.totalItem;
        const promotionAuctionListTotalItem = promotionAuctionList.totalCount;
        if (getUrlParms("announcement") && getUrlParms("announcement") == "1") {
          curTabIndex = 1;
        } else if (getUrlParms("agency") && getUrlParms("agency") == "1") {
          curTabIndex = 2;
        } else {
          if (auctionListNotEndListTotalItem > 0) {
            curTabIndex = 0;
          } else {
            if (promotionAuctionListTotalItem > 0) {
              curTabIndex = 1;
            } else {
              curTabIndex = 0;
            }
          }
        }
        setActive(curTabIndex);
      }
    });
  };
  
  return (
    <div className={styles.container}>
      <OrgInfo venderId={venderId} onLoadComplete={onOrgInfoLoaded} chuzhiNoticeTotalCount={chuzhiNoticeTotalCount}/>
      <ZhiboFloor venderId={venderId}></ZhiboFloor>
      {!!bannerList.length && <BannerSwiper bannerList={bannerList} vendorId={venderId} publishSource={publishSource}/>}
      <div className={styles.tabswrap}>
        <ul className={styles.tabs}>
          {tabs && tabs.length>0 && tabs.map((tab: any, index:number) => {
            const { id, name, clstag } = tab;
            return (
              <li
                className={classnames(styles.tab, {
                  [styles.active]: active === id
                })}
                key={index}
                onClick={() => setActive(id)}
                clstag={`pageclick|keycount|${clstag}`}
              >
                {name}
              </li>
            );
          })}
        </ul>
      </div>
      
      {active === 0 && <GoodsList venderId={venderId} publishSource={publishSource} />}
      {active === 1 && <RecommendList venderId={venderId} publishSource={publishSource} />}
      {parseInt(publishSource)===BUSINESS_INFO.POCHAN.code && active === 2 && <MechanismSelection venderId={venderId}/>}
      {parseInt(publishSource)===BUSINESS_INFO.POCHAN.code && active === 3 && <NoticeList venderId={venderId}/>}
      {parseInt(publishSource)===BUSINESS_INFO.ZICHAN.code && active === 3 && <PizhuanList venderId={venderId}/>}
      {parseInt(publishSource)===BUSINESS_INFO.ZICHAN.code && active === 4 && <ChuzhiNoticeList venderId={venderId}/>}
    </div>
  );
};

export default Index;
